import { margin } from "@mui/system";
import React from "react";
import DotsComponent from "../../DotsComponent";
import "../IDcard/IDCard.css";

const IDCard = () => {
  return (
    <>
      <div
        className="container"
        style={{ width: "30rem", margin: "0", marginRight: "1rem" }}
      >
      <DotsComponent/>
        <div
          style={{ textAlign: "center", padding: "10px", fontSize: "large" }}
        >
          <small className="camp-detail">Customers details</small>
        </div>
        <div className="sub-container">
          <div className="active">
          <div className="active-text"> Active</div>
          </div>

          <div className="allDetailsBox">
            <div>
              <div className="customername">
                <span>Customers ID : 87987987AD</span>
                <small style={{ fontSize: "12px" }}>
                  Signed-in On: 18th Aug 2022{" "}
                </small>
              </div>

              <div className="details">
                <span>
                  Ordered: <b>Jon Aches</b>
                </span>
                <label>Email ID :jonach.123@gmail.com </label>
                <span>
                  {" "}
                  Contact details: <b>+91-7833516223</b>
                </span>
                <span>
                  {" "}
                  Amount: Rs <b>98,000</b>
                </span>
                <span>
                  {" "}
                  Delivery: <b>Successfull</b>
                </span>
              </div>
            </div>

            <div className="image"></div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "0.5rem 5px 0 1rem",
              marginBottom:'20px'
            }}
          >
            <small>
              <b>Send mail now</b>
            </small>
            
          </div>
        </div>
      </div>
    </>
  );
};

export default IDCard;

